<template>
    <div>

    </div>
   </template>


<script>
import { mapGetters, mapActions, mapSetters, mapState } from 'vuex'
import axios from "axios";
import qs from 'qs';

export default {
    name: 'cognitoauth',
    mounted(){
        if (process.env.VUE_APP_IS_DEVELOPMENT === 'true') {
            this.devLogin();
        } else {
            const url = new URL(window.location.href);
            const code = url.searchParams.get('code');
            if (code) {
                this.prodLogin(code);
            } else {
                // No code in URL, do not trigger login again here
                // Optionally, show an error or redirect to login
                // this.$router.push('/Login');
                // Or show a message:
                console.error('No authorization code found in URL. Please login again.');
            }
        }
    },
    methods:{
        // handleAuth removed: login flow is now only triggered from LoginView.vue
        devLogin(){   
            console.log("dev login")
            this.$store.state.refresh_token = "dummy";
            this.$store.state.id_token = "dummy";
        },
        async prodLogin(code){
                var code_verifier = window.localStorage.getItem('pkce_code_verifier')
                var data = {
                    code: code,
                    client_id: process.env.VUE_APP_CLIENT_ID,
                    grant_type: 'authorization_code',
                    redirect_uri: process.env.VUE_APP_REDIRECT_URI,
                    code_verifier: code_verifier,
                }
                var queryString = this.getQueryString(data)
                try {
                    const response = await axios.request({
                    url: process.env.VUE_APP_AUTHORITY + 'oauth2/v2.0/token',
                    method: 'post',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded',
                    },
                    data: queryString,
                    })
                    this.$store.state.refresh_token = response.data.refresh_token
                    this.$store.state.id_token = response.data.id_token
                    //window.sessionStorage.setItem('id_token', this.$store.id_token)
                    this.getUser()
                } catch (error) {
                    //console.log('ERROR')
                    //console.log(error.response?.data)
                }
        },
        getQueryString(data = {}) {
            return Object.entries(data)
            .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
            .join('&')
        },
        getUser (){
            try {
                const idToken = this.$store.id_token
                const payload = idToken.split('.')[1]
                const decodedPayload = JSON.parse(decodeURIComponent(escape(window.atob(payload))))
                this.$store.sub = decodedPayload.sub
                this.$store.username =
                decodedPayload.name ||
                decodedPayload.preferred_username ||
                decodedPayload.email ||
                decodedPayload.unique_name
                console.log('Loaded user ' + this.$store.username)
                router.push('/')
            } catch (error) {
                console.log('Error decoding ID token:', error)
            }
        },  
        generateCodeVerifier() {
            const array = new Uint8Array(32)
            window.crypto.getRandomValues(array)
            return Array.from(array, (b) => ('0' + b.toString(16)).slice(-2)).join('')
        },
        base64UrlEncode(arrayBuffer) {
            let str = String.fromCharCode.apply(null, new Uint8Array(arrayBuffer))
            return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
        },
        async generateCodeChallenge(code_verifier) {
            const encoder = new TextEncoder()
            const data = encoder.encode(code_verifier)
            const digest = await window.crypto.subtle.digest('SHA-256', data)
            return this.base64UrlEncode(digest)
        }
    }
}




</script>




